<!-- Map -->
<div class="map-container">
    <google-map [width]="width" [height]="height" [options]="((getTempAddress$() | async) | google_map_format_converter: this._radius : disableDefaultUI) ?? defaultMapOptions"
                (mapInitialized)="onMapReady($event)" #googleMapContainer>
    </google-map>
</div>